<template>
  <div>
    <h2>Nicht gefunden.</h2>
  </div>
</template>
